import React from 'react';
import { Box } from '@mui/material';
import Layout from '../../../../App/components/Layout/LayoutContainer';
import { fetchPlans } from '../../PricingActions';
import TierPricingPage from './TierPricingPage';

const mainGridSx = {
  width: '100%',
  flex: '1 0 auto',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  maxWidth: 1280,
  alignSelf: 'center',
  margin: 'auto',
};

function PricingPage() {
  return (
    <Layout>
      <Box sx={mainGridSx}>
        <TierPricingPage />
      </Box>
    </Layout>
  );
}

PricingPage.loader =
  ({ dispatch }) =>
  ({ params }) => {
    const period = params?.period === '1y' ? '1y' : '1m';
    return dispatch(fetchPlans(period));
  };

export default PricingPage;
